const searchState = {
	READY: 0,
	SEARCHING: 1,
	DONE: 2,
	ERROR: 3,
};
export default searchState;
